function isIE() {
    // IE 10 and IE 11
    return /Trident\/|MSIE/.test(window.navigator.userAgent);
}

let showBrowserAlert = (function () {
    if (document.querySelector('.unsupported-browser')) {
        let d = document.getElementsByClassName('unsupported-browser');

        is_IE11 = isIE();

        if (is_IE11) {
            d[0].innerHTML = 'Din nettleser, Internet Explorer har gått ut på dato, og vil føre til at nettsider ikke fungerer som de skal. Du bør <a target="_blank" href="https://updatemybrowser.org/">oppdatere til en nyere nettleser</a>.';
            d[0].style.display = 'block';
        }
    }
});

document.addEventListener('DOMContentLoaded', showBrowserAlert);